import {CalendarDaySlot, CalendarTime} from "./CalendarDaySlot";

export class CalendarSlot{

    private day:number;
    private daySlots:Array<CalendarDaySlot>;

    constructor(day: number) {
        this.day = day;
        this.daySlots = [];
        this.daySlots.push(new CalendarDaySlot(CalendarTime.AM));
        this.daySlots.push(new CalendarDaySlot(CalendarTime.PM));
    }

    public SetDaySlots(daySlots:Array<CalendarDaySlot>){
        this.daySlots = daySlots;
    }

    public Day(): number {
        return this.day;
    }

    public DaySlots(): Array<CalendarDaySlot> {
        return this.daySlots;
    }

    public ToString():string{
        return '' + this.day;
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/entities/CalendarSlot.ts